<div class="card" [ngClass]="{'card-expand':fullScreen, 'bg-emphasis':!fullScreen}">

  <div class="card-body p-2 m-3px">
    <div class="d-flex fw-bold small mb-2 text-truncate text-uppercase" *ngIf="widget.showTitle">
      <span class="flex-grow-1">{{widget.name}} <div *ngIf="activePolling" class="sk-spinner sk-spinner-fading-circle"></div></span>
      <a class="text-default text-opacity-75 text-decoration-none mr-3" *ngIf="widget.enableLiveStreaming" (click)="toggleLiveStream()"><i [ngClass]="{'bi-camera-video':!liveStream,'bi-camera-video-fill':liveStream}" class="bi"></i></a>
      <a class="text-default text-opacity-75 text-decoration-none mr-3" *ngIf="selectedImage && selectedImage.length == 1 && selectedImage[0]?.value" (click)="refresh()"><i class="bi bi-arrow-repeat"></i></a>
      <a class="text-default text-opacity-75 text-decoration-none" (click)="toggleFullscreen()" data-bs-original-title="" title=""><i class="bi bi-fullscreen"></i></a>
    </div>

    <div class="image-container" *ngIf="w?.timeSeriesList && w.timeSeriesList.length == 1 && !liveStream">
      <smart-image-list
        #singleFeedList
        [images]="smartImageDetails"
        [isLoaded]="isLoaded"
        [aspectRatio]="w.aspectRatio"
        [showMetaData]="widget.showImageMetaData">
      </smart-image-list>
    </div>

    <div [ngClass]="{fullscreen:widgetComponent?.fullScreen && state}" *ngIf="w.timeSeriesList && w.timeSeriesList.length > 1 && !liveStream">
      <div>
        <div class="image-container" *ngIf="widgetComponent?.fullScreen && state">
          <smart-image [src]="selectedImage[state.index]?.value" [aspectRatio]="w.aspectRatio" [isLoaded]="isLoaded" [overlayConfig]="getSelectedImageOverlay(state.index)"></smart-image>
        </div>
        <div class="panorama">
          <table class="bearing">
            <tr *ngIf="widget.showBearing">
              <td *ngFor="let bearing of getBearings()">{{bearing}}</td>
            </tr>
            <tr>
              <td colspan="3" *ngFor="let ts of w.timeSeriesList; let i = index" (click)="showImage(i, ts)" [ngClass]="{selected:widgetComponent?.fullScreen && i==state?.index}">
                <smart-image [src]="images?.[i]?.[selectedImageIndex?.[i]]?.value" [aspectRatio]="w.aspectRatio" [isLoaded]="isLoaded" [overlayConfig]="getImageOverlay(i)"></smart-image>              
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div *ngIf="w.timeSeriesList && w.timeSeriesList.length >= 1 && liveStream" >
        <div class="ratio ratio-16x9">
          <img #livestream [src]="streamUrl" alt="Axis Camera Stream">
        </div>
        <div class="controls" *ngIf="widget.timeScroller">
          <span class="flex-grow-1">
            <button class="btn btn-sm btn-outline-default pr-4" [disabled]="true"><i class="fa fa-play"></i></button>
            <button class="btn btn-sm btn-outline-default pr-4" [disabled]="true"><i class="fa fa-backward"></i></button>
            <button class="btn btn-sm btn-outline-default pr-4" [disabled]="true"><i class="fa fa-forward"></i></button>
            <button class="btn btn-sm btn-outline-default pr-4" [disabled]="true"><i class="fa fa-repeat"></i></button>
            <span *ngIf="selectedImage[0]" class="clip">{{ currentTime | date:'medium' }}</span>
          </span>
          <span>
            <input type="range" class="form-range" [attr.disabled]="isLoaded ? null : true" id="formControlRange" 
              min="0" max="100"
              [(ngModel)]="timeout"/>
          </span>
        </div>
    </div>    

  </div>
</div>
